import { useState, useEffect } from 'react'
import { getTeamsAPI } from '../services/teams'

function UseTeams(orgId, divisionId, departmentId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      divisionId,
      departmentId
    }
    const getData = async () => {
      const result = await getTeamsAPI(param)
      if (!result) return

      const newData = result.result.map((d, i) => {
        return {
          value: d.id,
          label: d.team_en,
          label_th: d.team_th,
          count_emp: d.count_emp
        }
      })

      setData(newData)
    }
    if (orgId > 0 && divisionId > 0 && departmentId > 0) {
      getData()
    }
  }, [orgId, divisionId, departmentId])

  return data
}

export default UseTeams
